import { groupOrderItemsByPack } from "../../../../../helpers";
import { OrderAtomProps } from "../../OrderModal.types";
import { TotalBlock } from "./TotalBlock";

export const OrderMargin = ({ orderDetails }: OrderAtomProps) => {
  const grouped = groupOrderItemsByPack(orderDetails.items);

  const products = grouped.map((entry, index) => {
    if (entry.kind === "standalone") {
      const item = entry.item;
      const name = item.barcode?.productVariant?.name ?? "";
      const qtySuffix = item.quantity !== 1 ? ` (${item.quantity})` : "";
      return {
        label: `${name}${qtySuffix}`,
        price: item.margin * item.quantity
      };
    }

    const { group } = entry;
    const totalMargin = group.rows.reduce(
      (sum, row) => sum + row.margin * row.quantity,
      0
    );
    const priceCarrier = group.rows.find((row) => row.isPackPriceCarrier);
    const label =
      group.packTitle ??
      priceCarrier?.barcode?.productVariant?.name ??
      `Pack #${index + 1}`;
    return { label, price: totalMargin };
  });

  return (
    <TotalBlock
      label="Margin Breakdown"
      items={products}
      totalPrice={orderDetails.totalMargin}
      totalText="Total Margin"
      colors={{ backgroundColor: "#FFEBF1", color: "#FB3973" }}
    />
  );
};
